.flagContainer {
    display: flex;
}

.input {
    flex: 1.5;
    border-radius: 0;
}
